import React from 'react';
import { useLocation } from 'react-router-dom';
import SalesInvoicePrint from './SalesInvoicePrint';
import CreditNotePrint from './CreditNotePrint';

const InvoicePrint = () => {
  const location = useLocation();
  const { invoice } = location.state || {};

  if (!invoice) {
    return (
      <div className="print-container">
        <div className="alert alert-danger">No invoice data found</div>
      </div>
    );
  }

  // توجيه المستخدم إلى مكون الطباعة المناسب حسب نوع الفاتورة
  if (invoice.type === 'credit_note') {
    return <CreditNotePrint />;
  } else {
    return <SalesInvoicePrint />;
  }
};

export default InvoicePrint;
